
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function PublicationsPage() {
  const publications = [
    {
      title: 'From Moses to Messiah',
      author: 'Apostle Peter O. Akinnubi',
      description: 'The foundational training manual for the PAAM Global Mandate Training Program. A comprehensive study of Christ as the fulfillment of all Old Testament types and shadows.',
      category: 'Training Manual',
      image: 'https://readdy.ai/api/search-image?query=Professional%20book%20cover%20design%20with%20title%20From%20Moses%20to%20Messiah%2C%20elegant%20typography%2C%20simple%20background%2C%20warm%20golden%20lighting%2C%20spiritual%20and%20academic%20aesthetic%2C%20ministry%20publication%20style&width=300&height=400&seq=book1&orientation=portrait',
      status: 'Available'
    },
    {
      title: 'In Him: A Decade of Divine Mandates',
      author: 'Apostle Peter O. Akinnubi',
      description: 'A collection of prophetic messages and apostolic insights spanning ten years of divine revelations and ministry experiences.',
      category: 'Prophetic Messages',
      image: 'https://readdy.ai/api/search-image?query=Professional%20book%20cover%20design%20with%20title%20In%20Him%20A%20Decade%20of%20Divine%20Mandates%2C%20elegant%20typography%2C%20simple%20background%2C%20warm%20lighting%2C%20spiritual%20and%20prophetic%20aesthetic%2C%20ministry%20publication%20style&width=300&height=400&seq=book2&orientation=portrait',
      status: 'Available'
    },
    {
      title: 'The Apostolic Doctrine',
      author: 'PAAM Teaching Faculty',
      description: 'A comprehensive manual on apostolic doctrine and church order, essential for all CFN leaders and Bible college students.',
      category: 'Doctrine Manual',
      image: 'https://readdy.ai/api/search-image?query=Professional%20book%20cover%20design%20with%20title%20The%20Apostolic%20Doctrine%2C%20elegant%20typography%2C%20simple%20background%2C%20warm%20lighting%2C%20academic%20and%20spiritual%20aesthetic%2C%20doctrine%20manual%20style&width=300&height=400&seq=book3&orientation=portrait',
      status: 'Coming Soon'
    },
    {
      title: 'Christ Family Network Handbook',
      author: 'PAAM Leadership Team',
      description: 'Practical guide for establishing and leading CFN centers worldwide. Includes structure, protocols, and best practices.',
      category: 'Leadership Guide',
      image: 'https://readdy.ai/api/search-image?query=Professional%20book%20cover%20design%20with%20title%20Christ%20Family%20Network%20Handbook%2C%20elegant%20typography%2C%20simple%20background%2C%20warm%20lighting%2C%20practical%20and%20ministry%20aesthetic%2C%20leadership%20guide%20style&width=300&height=400&seq=book4&orientation=portrait',
      status: 'Available'
    }
  ];

  const resources = [
    {
      title: 'Bible College Curriculum',
      description: 'Comprehensive theological education materials for Bible colleges and ministry training institutes',
      icon: 'ri-graduation-cap-line'
    },
    {
      title: 'Digital Library',
      description: 'Online repository of sermons, teachings, and apostolic materials accessible worldwide',
      icon: 'ri-database-line'
    },
    {
      title: 'Educational Resources',
      description: 'Study guides, workbooks, and supplementary materials for spiritual formation',
      icon: 'ri-book-read-line'
    },
    {
      title: 'Publishing Services',
      description: 'Professional publishing support for ministry leaders and Christian authors',
      icon: 'ri-printer-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section 
        className="relative py-32 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(184, 20, 74, 0.8), rgba(184, 20, 74, 0.8)), url('https://readdy.ai/api/search-image?query=Modern%20library%20with%20books%20and%20digital%20resources%2C%20warm%20lighting%2C%20academic%20atmosphere%2C%20knowledge%20and%20learning%20environment%2C%20simple%20background%2C%20educational%20and%20spiritual%20context&width=1920&height=800&seq=libraryhero&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl font-bold mb-6">Gallery of Revelation Network</h1>
          <p className="text-xl max-w-4xl mx-auto mb-8">
            Library, Publishing, Christian education, doctrine manuals, and training for Bible colleges
          </p>
          <Link 
            to="/join"
            className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            Access Resources
          </Link>
        </div>
      </section>

      {/* Publications Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Featured Publications</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Apostolic literature and training materials designed to ground believers in sound doctrine 
              and equip them for effective ministry.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {publications.map((book, index) => (
              <div key={index} className="bg-gray-50 rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <div className="aspect-w-3 aspect-h-4">
                  <img 
                    src={book.image}
                    alt={book.title}
                    className="w-full h-80 object-cover"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs font-semibold text-[#b8144a] bg-red-50 px-2 py-1 rounded">
                      {book.category}
                    </span>
                    <span className={`text-xs font-semibold px-2 py-1 rounded ${
                      book.status === 'Available' 
                        ? 'text-green-700 bg-green-50' 
                        : 'text-orange-700 bg-orange-50'
                    }`}>
                      {book.status}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{book.title}</h3>
                  <p className="text-sm text-gray-600 mb-3">{book.author}</p>
                  <p className="text-sm text-gray-700 mb-4">{book.description}</p>
                  <Link 
                    to="/join"
                    className="text-[#b8144a] hover:text-[#a01240] font-semibold text-sm cursor-pointer"
                  >
                    Learn More →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Resources Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Educational Resources</h2>
            <p className="text-xl text-gray-600">Comprehensive tools for spiritual formation and ministry training</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {resources.map((resource, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${resource.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{resource.title}</h3>
                <p className="text-gray-700">{resource.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bible College Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Bible College Training</h2>
              <p className="text-lg text-gray-700 mb-6">
                The Gallery of Revelation Network provides comprehensive curriculum and training materials 
                for Bible colleges and ministry training institutes worldwide.
              </p>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-[#b8144a] text-lg"></i>
                  <span className="text-gray-700">Systematic theology courses</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-[#b8144a] text-lg"></i>
                  <span className="text-gray-700">Apostolic doctrine manuals</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-[#b8144a] text-lg"></i>
                  <span className="text-gray-700">Ministry training modules</span>
                </div>
                <div className="flex items-center space-x-3">
                  <i className="ri-check-line text-[#b8144a] text-lg"></i>
                  <span className="text-gray-700">Leadership development programs</span>
                </div>
              </div>
              <div className="mt-8">
                <Link 
                  to="/training"
                  className="bg-[#b8144a] hover:bg-[#a01240] text-white px-6 py-3 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  Explore Training
                </Link>
              </div>
            </div>
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=Bible%20college%20classroom%20with%20students%20studying%2C%20warm%20lighting%2C%20academic%20atmosphere%2C%20books%20and%20learning%20materials%2C%20simple%20background%2C%20educational%20and%20spiritual%20context&width=600&height=400&seq=biblecollege&orientation=landscape"
                alt="Bible College Training"
                className="rounded-lg shadow-lg object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Digital Library */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Digital Library Access</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Access thousands of sermons, teachings, and apostolic materials through our comprehensive digital library
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-12 text-center">
            <div className="w-24 h-24 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-8">
              <i className="ri-cloud-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Coming Soon: Digital Platform</h3>
            <p className="text-lg text-gray-700 mb-8 max-w-2xl mx-auto">
              Our comprehensive digital library platform will provide instant access to all PAAM publications, 
              training materials, and educational resources from anywhere in the world.
            </p>
            <Link 
              to="/join"
              className="bg-[#b8144a] hover:bg-[#a01240] text-white px-8 py-3 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Early Access
            </Link>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Grow in Knowledge and Wisdom</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Join the Gallery of Revelation Network and access the apostolic resources that will 
            ground you in truth and equip you for effective ministry.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/join"
              className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Access Resources
            </Link>
            <Link 
              to="/training"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-[#b8144a] transition-colors whitespace-nowrap cursor-pointer"
            >
              Start Learning
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
